// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLayout_layout__PzM44 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.MainLayout_main__XDITe {
  flex: 1 1;
  height: 100vh;
  padding: 0;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/layouts/MainLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AACF","sourcesContent":[".layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f5f5;\n}\n\n.main {\n  flex: 1;\n  height: 100vh;\n  padding: 0;\n  overflow: hidden;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `MainLayout_layout__PzM44`,
	"main": `MainLayout_main__XDITe`
};
export default ___CSS_LOADER_EXPORT___;
